
(() => {
  'use strict';

  /* ==========================================
     NCFRS | VARIANTES PREMIUM PARA HORIZON
     Todos los productos
     Carruseles con posición persistente
     ========================================== */

  const normalize = value =>
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();

  const palette = {
    verde: '#006039',
    azul: '#245BBA',
    rojo: '#C52B32',
    'rojo mate': '#C52B32',
    amarillo: '#F4CA30',
    naranja: '#F58220',
    purpura: '#763AAB',
    morado: '#763AAB',
    dorado: '#A37E2C',
    negro: '#171717',
    blanco: '#FFFFFF',
    plata: '#C0C4C8',
  };

  
const descriptions = {
  clasico: 'Solo numeración\nde identificacion',
  fino: 'Grabado a\nprofundidad',
  elite: 'Grabado a profundidad\ncon Letras a color'
};


  // Guardar posiciones cuando Horizon actualiza
  // los elementos de la página.
  const positions = new Map();

  function getType(name) {
    const value = normalize(name);

    if (value === 'color') return 'color';
    if (value === 'serie') return 'serie';
    if (value === 'numeracion') return 'numeracion';

    return null;
  }

  function getKey(picker, type) {
    const pickers = Array.from(
      document.querySelectorAll('variant-picker')
    );

    const index = pickers.indexOf(picker);

    return [
      window.location.pathname,
      index,
      type
    ].join('::');
  }

  function savePosition(carousel) {
    const track = carousel.querySelector('.ncfrs-track');
    if (!track) return;

    const key = carousel.dataset.ncfrsKey;
    if (!key) return;

    positions.set(key, track.scrollLeft);
  }

  function updateArrows(carousel) {
    const track = carousel.querySelector('.ncfrs-track');
    if (!track) return;

    const max = Math.max(
      0,
      track.scrollWidth - track.clientWidth
    );

    const prev = carousel.querySelector('.ncfrs-prev');
    const next = carousel.querySelector('.ncfrs-next');

    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
  }

  function restorePosition(carousel) {
    const track = carousel.querySelector('.ncfrs-track');
    const key = carousel.dataset.ncfrsKey;

    if (!track || !key) return;

    // No mover el carrusel si nunca tuvo posición.
    if (!positions.has(key)) {
      updateArrows(carousel);
      return;
    }

    const saved = positions.get(key);

    const restore = () => {
      if (!track.isConnected) return;

      const max = Math.max(
        0,
        track.scrollWidth - track.clientWidth
      );

      const target = Math.min(saved, max);

      // Evita animar desde el principio
      // al recuperar el carrusel.
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = target;

      updateArrows(carousel);

      requestAnimationFrame(() => {
        track.style.scrollBehavior = '';
      });
    };

    requestAnimationFrame(() => {
      restore();
      requestAnimationFrame(restore);
    });
  }

  function createArrow(direction, label, symbol) {
    const button = document.createElement('button');

    button.type = 'button';
    button.className =
      `ncfrs-arrow ncfrs-${direction}`;

    button.setAttribute('aria-label', label);
    button.textContent = symbol;

    return button;
  }

  function enhancePicker(picker) {
    // Funciona en cualquier producto.
    // No depende del handle o nombre del producto.

    const fieldsets = picker.querySelectorAll(
      'fieldset.variant-option--buttons'
    );

    fieldsets.forEach(fieldset => {

      if (fieldset.dataset.ncfrsDone === '1') return;

      const radio = fieldset.querySelector(
        'input[type="radio"]'
      );

      if (!radio) return;

      // Identificar nombre de la opción.
      const optionName =
        radio.dataset.optionName ||
        fieldset.querySelector('legend')?.textContent ||
        '';

      const type = getType(optionName);

      // No modificar opciones ajenas.
      if (!type) return;

      const labels = Array.from(fieldset.children)
        .filter(element =>
          element.matches(
            'label.variant-option__button-label'
          )
        );

      if (!labels.length) return;

      // Marcar como procesado.
      fieldset.dataset.ncfrsDone = '1';
      fieldset.classList.add(`ncfrs-${type}`);
      picker.classList.add('ncfrs-enhanced');

      labels.forEach(label => {
        const input = label.querySelector(
          'input[type="radio"]'
        );

        const value = input?.value || '';
        const normalized = normalize(value);

        /* COLOR */
        if (type === 'color') {
          label.style.setProperty(
            '--ncfrs-color',
            palette[normalized] || '#D4D6D5'
          );

          if (!label.querySelector(
            '.variant-option__button-label__text'
          )) {
            const caption = document.createElement('span');

            caption.className =
              'variant-option__button-label__text ncfrs-caption';

            caption.textContent = value;
            label.appendChild(caption);
          }
        }

        /* SERIE */
        if (type === 'serie') {
          const description = descriptions[normalized];

          if (
            description &&
            !label.querySelector('.ncfrs-subtitle')
          ) {
            const subtitle = document.createElement('span');

            subtitle.className = 'ncfrs-subtitle';
            subtitle.textContent = description;

            label.appendChild(subtitle);
          }
        }
      });

      /* =================================
         SERIE: TARJETAS SIN CARRUSEL
         ================================= */

      if (type === 'serie') {
        const grid = document.createElement('div');

        grid.className = 'ncfrs-series-grid';

        labels.forEach(label => {
          grid.appendChild(label);
        });

        fieldset.appendChild(grid);
        return;
      }

      /* =================================
         COLOR Y NUMERACIÓN: CARRUSELES
         ================================= */

      const carousel = document.createElement('div');
      carousel.className = 'ncfrs-carousel';

      const track = document.createElement('div');
      track.className = 'ncfrs-track';

      // Identificador para conservar la posición
      carousel.dataset.ncfrsKey = getKey(picker, type);

      const prev = createArrow(
        'prev',
        'Ver opciones anteriores',
        '‹'
      );

      const next = createArrow(
        'next',
        'Ver más opciones',
        '›'
      );

      carousel.append(prev, track, next);

      // Mover los botones originales de Shopify.
      labels.forEach(label => {
        track.appendChild(label);
      });

      fieldset.appendChild(carousel);

      // Guardar posición al deslizar.
      track.addEventListener(
        'scroll',
        () => {
          savePosition(carousel);
          updateArrows(carousel);
        },
        { passive: true }
      );

      // Recuperar posición después de renderizar.
      restorePosition(carousel);
    });
  }

  /* ====================================
     INICIALIZAR TODOS LOS PRODUCTOS
     ==================================== */

  function enhanceAll() {
    document
      .querySelectorAll('variant-picker')
      .forEach(enhancePicker);
  }

  let scheduled = false;

  function schedule() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      enhanceAll();
    });
  }

  /* ====================================
     NAVEGACIÓN CON FLECHAS
     ==================================== */

  document.addEventListener('click', event => {
    const arrow = event.target.closest(
      '.ncfrs-arrow'
    );

    if (!arrow) return;

    const carousel = arrow.closest('.ncfrs-carousel');
    const track = carousel?.querySelector('.ncfrs-track');

    if (!track) return;

    const direction =
      arrow.classList.contains('ncfrs-next')
        ? 1
        : -1;

    track.scrollBy({
      left: direction *
        Math.max(100, track.clientWidth * 0.75),
      behavior: 'smooth'
    });
  });

  /* ====================================
     CONSERVAR POSICIÓN AL SELECCIONAR
     ==================================== */

  document.addEventListener(
    'change',
    event => {
      if (!event.target.matches(
        'variant-picker input[type="radio"]'
      )) return;

      // Guardar todos los carruseles antes
      // de que Horizon vuelva a renderizar.
      const picker = event.target.closest('variant-picker');

      if (!picker) return;

      picker
        .querySelectorAll('.ncfrs-carousel')
        .forEach(savePosition);
    },
    true
  );

  /* ====================================
     OBSERVAR CAMBIOS DE HORIZON
     ==================================== */

  function start() {
    schedule();

    const observer = new MutationObserver(() => {
      schedule();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start
    );
  } else {
    start();
  }

  /* ====================================
     AJUSTES RESPONSIVE
     ==================================== */

  window.addEventListener('resize', () => {
    document
      .querySelectorAll('.ncfrs-carousel')
      .forEach(updateArrows);
  });

  document.addEventListener(
    'shopify:section:load',
    schedule
  );
})();



